import { loadState } from 'storeCache';
import AppConfig from '../util/config';

// console.log('Init API with', JSON.stringify(AppConfig));

export default function api(url, options) {
  const token = getTokenFromState();
  options = {
    ...options,
    headers: {
      ...(options ? options.headers : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json'
    },
    mode: 'cors'
  };

  return fetch(`${AppConfig.API_URL}${url}`, options).then(response => {
    if (!response.ok) {
      return response.json().then(err => {
        throw new Error(err.error || err.message);
      });
    }
    return response.json();
  });
}

function getTokenFromState() {
  let state = loadState();
  if (state && state.auth && state.auth.token) {
    return state.auth.token;
  } else {
    return null;
  }
}
